import {  useQuery } from '@tanstack/react-query';
import { useDashboardApi } from '../../hooks/useDashboardApi';

type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
  fromDate?: string;
  toDate?: string;
};

export const useGetAllDashboard = (queryParams: Params) => {

  const { getAllDashboard } = useDashboardApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getCoupon', queryParams],
    queryFn: () => {
      return getAllDashboard(queryParams);
    },
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch
  };
};




